var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bo-user-list',{attrs:{"title":"Utilisateurs","subtitle":"Back Office","storePrefix":"bouser","routePrefix":"users","keepLast":true,"parentAll":_vm.all}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }